module.exports = __webpack_public_path__ + "static/img/43成都健身.e898974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/43成都健身.jpg
// module id = uNVS
// module chunks = 1